import { createFileRoute } from "@tanstack/react-router"
import { AddInstagramIntegration } from "modules/settings/components/integrations/instagram/AddInstagramIntegration"
import { InstagramAuthorizeSchema } from "schema"
import z from "zod"

export const Route = createFileRoute("/_base/_auth/settings/channels/instagram/new")({
  component: AddInstagramIntegration,
  validateSearch: (search: Partial<z.infer<typeof InstagramAuthorizeSchema>>) => {
    return InstagramAuthorizeSchema.parse(search)
  },
})
